import httpUserClient from '@/plugins/httpUserClient';

export default {
  getUserInfo() {
    return httpUserClient.get('user/info');
  },
  patchUserInfo(data) {
    return httpUserClient.patch('user/info', { user_info: { ...data } });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userApis/train/userCenterApis.js